import {createFileRoute, redirect} from '@tanstack/react-router'
import {LoginForm} from "../components/Auth/LoginForm.tsx";
import {isAuthenticated} from "../utils/auth.ts";

export const Route = createFileRoute('/')({
  beforeLoad: async () => {
    if(isAuthenticated()) {
      throw redirect({to: '/sessions', replace: true});
    }
  },
  component: LoginForm,
})